import React from 'react';
export function Footer() {
  return <footer className="bg-[#050a14] text-white pt-20 pb-10 border-t border-white/5 relative overflow-hidden" data-id="element-35">
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[300px] bg-[#f59e0b]/5 blur-[100px] rounded-full pointer-events-none" data-id="element-36"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-37">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12 mb-16" data-id="element-38">
          {/* Brand */}
          <div className="space-y-6" data-id="element-39">
            <div className="flex items-center gap-2" data-id="element-40">
              <img src="https://cdn.magicpatterns.com/uploads/vrJu2JQ1pWM588A88QqcHb/4_-_Small.png" alt="Nawat Tech Logo" className="h-10 w-auto" data-id="element-41" />
            </div>
            <p className="text-gray-400 leading-relaxed" data-id="element-42">
              Pioneering advanced tech and cybersecurity solutions in the UAE.
              Turning digital dreams into reality.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-43">
            <h3 className="text-lg font-bold mb-6 text-white" data-id="element-44">Quick Links</h3>
            <ul className="space-y-4" data-id="element-45">
              {['Home', 'About Us', 'Services', 'Our Mission', 'Contact Us'].map(link => <li key={link} data-id="element-46">
                  <a href={`#${link.toLowerCase().replace(' ', '')}`} className="text-gray-400 hover:text-[#f59e0b] transition-colors flex items-center gap-2 group" data-id="element-47">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#f59e0b] opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-48"></span>
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-49">
            <h3 className="text-lg font-bold mb-6 text-white" data-id="element-50">Services</h3>
            <ul className="space-y-4" data-id="element-51">
              {['AI Solutions', 'Cybersecurity', 'Cloud Services', 'Tech Consulting', 'Data Analytics'].map(link => <li key={link} data-id="element-52">
                  <a href="#" className="text-gray-400 hover:text-[#f59e0b] transition-colors flex items-center gap-2 group" data-id="element-53">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#f59e0b] opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-54"></span>
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-gray-500 text-sm" data-id="element-55">
          <p data-id="element-56">
            &copy; {new Date().getFullYear()} Nawat Tech. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-57">
            <a href="#" className="hover:text-white transition-colors" data-id="element-58">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-59">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}